import React from 'react';

export default class CordellConnectUsers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      size: 1,
      usersPackage: [],
      showMoreUsersOption: true,
      selectedUser: 2
    };
  }

  /* istanbul ignore next */
  showMoreUsers() {
    if (this.state.showMoreUsersOption) {
      this.setState({
        showMoreUsersOption: false,
        size: this.state.usersPackage.length
      });
    } else {
      this.setState({
        showMoreUsersOption: true,
        size: 10
      });
    }
  }

  /* istanbul ignore next */
  selectUser(user, usersPackage, clickAction) {
    this.props.onSelectingCordellUser(user);

    if (clickAction) {
      this.props.onUserClickAction();
    }

    //update the pricing for users
    let userPrice, userIndex;
    let pricePerUser = this.props.users.price_per_user;

    for (let eachUser = 0; eachUser <= usersPackage.length - 1; eachUser++) {
      userIndex = parseInt(usersPackage[eachUser].number, 10) - user;
      userPrice = Math.abs(pricePerUser * userIndex).toFixed(2);
      if (userIndex === 0) {
        usersPackage[eachUser].value = 'Selected';
      } else if (usersPackage[eachUser].number > user) {
        usersPackage[eachUser].value = `+$${userPrice}`;
      } else if (usersPackage[eachUser].number < user) {
        usersPackage[eachUser].value = `-$${userPrice}`;
      }
    }

    //set the updated users value
    this.setState({
      usersPackage: usersPackage,
      selectedUser: user
    });
  }

  componentDidMount() {
    let counter = 0,
      userPrice,
      size = 1;
    let usersPackage = [];
    let pricePerUser = this.props.users.price_per_user;
    if (this.props.users.max_number_users === undefined) {
      usersPackage.push({ number: 2, value: 'Included' });
    } else {
      for (
        let user = parseInt(this.props.users.default_users, 10);
        user <= this.props.users.max_number_users;
        user++
      ) {
        if (user === parseInt(this.props.users.default_users, 10)) {
          usersPackage.push({ number: user, value: 'Included' });
        } else {
          counter++;
          userPrice = (pricePerUser * counter).toFixed(2);
          usersPackage.push({ number: user, value: `+$${userPrice}` });
        }
      }
    }

    if (usersPackage.length > 10) {
      size = 10;
    } else {
      size = usersPackage.length;
    }

    this.setState({
      size: size,
      selectedUser:
        this.props.selectedUser != null
          ? this.props.selectedUser
          : parseInt(this.props.users.default_users, 10)
    });

    if (this.props.selectedUser != null) {
      this.selectUser(this.props.selectedUser, usersPackage, false);
    } else {
      this.setState({
        usersPackage: usersPackage
      });
    }
  }

  render(props) {
    let usersList = this.state.usersPackage
      .slice(0, this.state.size)
      .map(function (singleUser, index) {
        let classNames = require('classnames');
        let userTileClass = classNames({
          alert: this.state.selectedUser !== singleUser.number,
          'alert alert-success': this.state.selectedUser === singleUser.number
        });
        return (
          <div
            className={userTileClass}
            key={index}
            onClick={() => {
              this.selectUser(singleUser.number, this.state.usersPackage, true);
            }}
          >
            <div className='row'>
              <div className='col-xs-8'>
                {singleUser.number} {singleUser.number === 1 ? 'User' : 'Users'}
              </div>
              <div className='col-xs-4 text-right'>{singleUser.value}</div>
            </div>
          </div>
        );
      }, this);
    return (
      <div className='panel-body-spacing'>
        {usersList}
        <div className='row font-14 no-margin grey-text pointer'>
          <div className='col-xs-12'>
            {this.state.usersPackage.length > 10 && this.state.showMoreUsersOption && (
              <span
                onClick={() => {
                  this.showMoreUsers();
                }}
              >
                Show more
              </span>
            )}
            {this.state.usersPackage.length > 10 && !this.state.showMoreUsersOption && (
              <span
                onClick={() => {
                  this.showMoreUsers();
                }}
              >
                Show less
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}
